import React, { Fragment, Suspense, useContext, useEffect, useState } from "react";
import { Route } from "react-router-dom";
import { Container, StyledBody } from "./header.style";

import { Toaster } from "react-hot-toast";
import { IRoute, routes } from "../../routes.path";
import SystemContext from "../../context/systemContext";
import RoleManager from "../../services/roleManagement";
import Loader from "../../components/loaders/pageLoader";
import { useAppSelector } from "../../store/storeHooks";

export interface IPrivateProps extends IRoute {
  children: JSX.Element | null;
}

let PrivateRoute: React.FC<IPrivateProps>;

PrivateRoute = ({ children, ...rest }: any) => {
  const context = useContext(SystemContext);
  const [hasAccess] = RoleManager();
  const { value } = useAppSelector((state) => state.sideBarData);


  return (
    <Fragment key={rest.key}>
      <Suspense
        fallback={
          <div className="position-relative" style={{ height: "100%" }}>
            <Loader />
          </div>
        }
      >
        <Container sidebar={value} id="content">
          {/* <Header /> */}
          <StyledBody>
            {rest.id === "settings" ? (
              rest?.child?.find((ch: any) => hasAccess(ch.id)) ? (
                <Route {...rest} render={({ location }) => children} />
              ) : (
                ""
              )
            ) : hasAccess(rest.id) || rest.id === "home" ? (
              <Route {...rest} render={({ location }) => children} />
            ) : (
              ""
            )}
          </StyledBody>
        </Container>
        <Toaster containerStyle={{ zIndex: "9999999" }} />
      </Suspense>
    </Fragment>
  );
};

export default PrivateRoute;
